import { XhrMethods as xhr, XhrTypes as xht } from './enums'

export const foundation = {
  uploadFile: {
    url: '/foundation/file/upload',
    method: xhr.post,
    type: xht.body
  },
  uploadFiles: {
    url: '/foundation/file/batch/upload',
    method: xhr.post,
    type: xht.body
  },
  areaQuery: {
    url: '/foundation/area/query/child',
    method: xhr.get,
    type: xht.query
  },
  dictListType: {
    url: '/saas/dict/list_with_type',
    method: xhr.get,
    type: xht.query
  },
  dictListIds: {
    url: '/saas/dict/list_with_ids',
    method: xhr.get,
    type: xht.query
  },
  sendVerifyCode: {
    url: '/foundation/sms/send/verify_code',
    method: xhr.post,
    type: xht.query
  }
}

export const user = {
  login: {
    method: xhr.post,
    url: '/saas/user/login',
    type: xht.body
  },
  menu: {
    method: xhr.get,
    url: '/user/menu',
    type: xht.body
  },
  providerInfo: {
    method: xhr.post,
    url: '/saas/user/provider/info',
    type: xht.query
  },
  outsourceInfo: {
    method: xhr.post,
    url: '/saas/user/outsourcer/info',
    type: xht.query
  },
  //获取当前用户 用户信息接口
  userInfo: {
    url: '/saas/user/info',
    method: xhr.get,
    type: xht.query
  },
  //外包商注册
  outsourceRegister: {
    url: '/saas/user/outsourcer/register',
    method: xhr.post,
    type: xht.body
  },
  checkoutCode: {
    url: '/saas/user/checkout/code',
    method: xhr.post,
    type: xht.body
  },
  updatePassword: {
    url: '/saas/user/step/update/password',
    method: xhr.post,
    type: xht.body
  }
}

//order 订单模块
export const order = {
  //工单事件
  orderEvents: {
    url: '/saas/order/all_event/list',
    method: xhr.get,
    type: xht.query
  },
  //工单催单
  orderRemind: {
    url: '/saas/order/remind_with_manual',
    method: xhr.get,
    type: xht.query
  },
  // 查询绩效列表
  performanceTypeList: {
    url: '/saas/performance/type/list',
    method: xhr.post,
    type: xht.body
  },
  // 创建绩效列表
  performanceTypeCreate: {
    url: '/saas/performance/type/create',
    method: xhr.post,
    type: xht.body
  },
  // 修改绩效列表
  performanceTypeModify: {
    url: '/saas/performance/type/modify',
    method: xhr.post,
    type: xht.body
  },
  // 删除绩效列表
  performanceTypeDelete: {
    url: '/saas/performance/type/delete',
    method: xhr.get,
    type: xht.body
  },
  // 工程师列表
  orderEngineerList: {
    url: '/saas/order/engineer/list',
    method: xhr.post,
    type: xht.body
  },
  // 工程师列表
  orderReject: {
    url: '/saas/order/reject',
    method: xhr.post,
    type: xht.body
  },
  // 工程师列表
  orderEquipmentContentInfo: {
    url: '/saas/order/equipment/content_info',
    method: xhr.get,
    type: xht.query
  }
}

export const repair = {
  orderList: {
    url: '/saas/repair/order/list',
    method: xhr.post,
    type: xht.body
  },
  repairOrderExport: {
    url: '/saas/repair/order/export',
    method: xhr.post,
    type: xht.body
  },
  orderCreate: {
    url: '/saas/repair/order/create',
    method: xhr.post,
    type: xht.body
  },
  orderDetail: {
    url: '/saas/repair/order/detail',
    method: xhr.get,
    type: xht.query
  },
  orderClose: {
    url: '/saas/repair/order/close',
    method: xhr.post,
    type: xht.query
  },
  orderDispatch: {
    url: '/saas/repair/order/dispatch',
    method: xhr.post,
    type: xht.body
  },
  orderReDispatch: {
    url: '/saas/repair/order/redispatch',
    method: xhr.post,
    type: xht.body
  },
  orderEventList: {
    url: '/saas/repair/order/event/list',
    method: xhr.get,
    type: xht.query
  },
  orderEngineers: {
    url: '/saas/repair/order/engineer',
    method: xhr.get,
    type: xht.query
  },
  orderReply: {
    url: '/saas/repair/order/reply',
    method: xhr.post,
    type: xht.query
  },
  //评价工程单
  estimateRepairOrderDetail: {
    url: '/saas/repair/order/comment',
    method: xhr.post,
    type: xht.body
  },
  //获取评价信息
  orderCommentInfo: {
    url: '/saas/repair/order/comment_info',
    method: xhr.get,
    type: xht.query
  },
  // 删除绩效列表
  orderApprove: {
    url: '/saas/order/approve',
    method: xhr.post,
    type: xht.body
  }
}

export const project = {
  orderList: {
    url: '/saas/project/list',
    method: xhr.post,
    type: xht.body
  },
  orderCreate: {
    url: '/saas/project/create',
    method: xhr.post,
    type: xht.body
  },
  orderDetail: {
    url: '/saas/project/detail',
    method: xhr.get,
    type: xht.query
  },
  orderAudit: {
    url: '/saas/project/audit',
    method: xhr.post,
    type: xht.query
  },
  orderPublish: {
    url: '/saas/project/publish',
    method: xhr.post,
    type: xht.body
  },
  materialList: {
    url: '/saas/project/material/list',
    method: xhr.get,
    type: xht.query
  },
  //项目材料
  applyMaterial: {
    url: '/saas/project/apply_material',
    method: xhr.post,
    type: xht.body
  },
  // 工程单费用 变更列表（详情页使用）
  costGroup: {
    url: '/saas/project/cost/list_with_group',
    method: xhr.get,
    type: xht.query
  },
  //工程单费用apply
  costApply: {
    url: '/saas/project/cost/apply',
    method: xhr.post,
    type: xht.body
  },
  //费用变更审核 列表
  costList: {
    url: '/saas/project/cost/list',
    method: xhr.post,
    type: xht.body
  },
  costAudit: {
    url: '/saas/project/cost/audit',
    method: xhr.post,
    type: xht.query
  },
  feeStat: {
    url: '/saas/project/fee_stat',
    method: xhr.get,
    type: xht.query
  },
  projectEvents: {
    url: '/saas/order/all_event/list',
    method: xhr.get,
    type: xht.query
  },
  //订单跟进
  projectFollow: {
    url: '/saas/order/follow_log/list',
    method: xhr.get,
    type: xht.query
  },
  //获取工单需求
  projectRequirement: {
    url: '/saas/project/requirement',
    method: xhr.get,
    type: xht.query
  },
  //外包商竞标列表
  projectBidList: {
    url: '/saas/project/bid/list',
    method: xhr.get,
    type: xht.query
  },
  //派单给外包商
  dispatchOutsourcer: {
    url: '/saas/project/select_outsourcer',
    method: xhr.post,
    type: xht.query
  },
  //改派
  reDispatchOutsourcer: {
    url: '/saas/project/reselect_outsourcer',
    method: xhr.post,
    type: xht.query
  },
  //初审
  auditFirst: {
    url: '/saas/project/first_audit',
    method: xhr.post,
    type: xht.body
  },
  //终审
  finalAudit: {
    url: '/saas/project/final_audit',
    method: xhr.post,
    type: xht.query
  },
  //费用统计
  projectFeeStat: {
    url: '/saas/project/fee_stat',
    method: xhr.get,
    type: xht.query
  }
}

export const engineering = {
  //费用统计
  engineeringTaskTypePage: {
    url: '/saas/engineering/task/type/page',
    method: xhr.post,
    type: xht.body
  },
  engineeringTaskTypePage: {
    url: '/saas/engineering/task/type/page',
    method: xhr.post,
    type: xht.body
  },
  engineeringTaskTypeCreate: {
    url: '/saas/engineering/task/type/create',
    method: xhr.post,
    type: xht.body
  },
  engineeringTaskTypeDelete: {
    url: '/saas/engineering/task/type/delete',
    method: xhr.get,
    type: xht.query
  },
  engineeringTaskTypeDeleteBatch: {
    url: '/saas/engineering/task/type/delete/batch',
    method: xhr.get,
    type: xht.query
  },
  engineeringTaskTypeModify: {
    url: '/saas/engineering/task/type/modify',
    method: xhr.post,
    type: xht.body
  },
  engineeringProjectPage: {
    url: '/saas/engineering/project/page',
    method: xhr.post,
    type: xht.body
  },
  engineeringProjectCreate: {
    url: '/saas/engineering/project/create',
    method: xhr.post,
    type: xht.body
  },
  engineeringProjectDetail: {
    url: '/saas/engineering/project/detail',
    method: xhr.get,
    type: xht.query
  },
  engineeringProjectClose: {
    url: '/saas/engineering/project/close',
    method: xhr.get,
    type: xht.query
  },
  engineeringProjectApprove: {
    url: '/saas/engineering/project/approve',
    method: xhr.post,
    type: xht.body
  },
  engineeringOrderDetail: {
    url: '/saas/engineering/order/detail',
    method: xhr.get,
    type: xht.query
  }
}

export const projectFlow = {
  changeFeeList: {
    url: '/project_flow/change_fee_list',
    method: xhr.post,
    type: xht.body
  },
  audit: {
    url: '/project_flow/audit',
    method: xhr.post,
    type: xht.body
  }
}

export const inspection = {
  maintainList: {
    url: '/saas/maintain/list',
    method: xhr.post,
    type: xht.body
  },
  inspectOrderPage: {
    url: '/saas/inspect/order/page',
    method: xhr.post,
    type: xht.body
  },
  inspectOrderDetailBase: {
    url: '/saas/inspect/order/detail/base',
    method: xhr.get,
    type: xht.query
  },
  inspectOrderDetailInfo: {
    url: '/saas/inspect/order/detail/info',
    method: xhr.get,
    type: xht.query
  },
  inspectOrderDetailTemplate: {
    url: '/saas/inspect/order/detail/template',
    method: xhr.get,
    type: xht.query
  },
  inspectOrderDetailProgressTotal: {
    url: '/saas/inspect/order/detail/progress/total',
    method: xhr.get,
    type: xht.query
  },
  inspectOrderDetailProgressList: {
    url: '/saas/inspect/order/detail/progress/list',
    method: xhr.post,
    type: xht.body
  },
  inspectProgressCheckList: {
    url: '/saas/inspect/order/detail/progress/check_list',
    method: xhr.get,
    type: xht.query
  },
  inspectProgressComment: {
    url: '/saas/inspect/order/detail/progress/comment',
    method: xhr.get,
    type: xht.query
  },
  getChildCustomerInfo: {
    url: '/saas/maintain/detail',
    method: xhr.get,
    type: xht.query
  },
  inspectOrderCreate: {
    url: '/saas/inspect/order/create',
    method: xhr.post,
    type: xht.body
  },
  inspectOrderDispatch: {
    url: '/saas/inspect/order/dispatch',
    method: xhr.post,
    type: xht.body
  },
  inspectOrderClose: {
    url: '/saas/inspect/order/close',
    method: xhr.post,
    type: xht.query
  },
  // 巡检单详情
  inspectOrderChildPerformance: {
    url: '/saas/inspect/order/child/performance',
    method: xhr.get,
    type: xht.query
  },
  inspectOrderEngineerList: {
    url: '/saas/inspect/order/engineer/list',
    method: xhr.get,
    type: xht.query
  },
  inspectOrderChildClose: {
    url: '/saas/inspect/order/child/close',
    method: xhr.get,
    type: xht.query
  }
}

export const warning = {
  orderList: {
    url: '/saas/smart_maintenance/fault_warning/page',
    method: xhr.post,
    type: xht.body
  },
  faultTypeList: {
    url: '/saas/smart_maintenance/fault_type',
    method: xhr.get
  },
  faultStatusList: {
    url: '/saas/smart_maintenance/fault_status',
    method: xhr.get
  },
  noHandleNum: {
    url: '/saas/smart_maintenance/no_handle/num',
    method: xhr.get
  },
  handleWarning: {
    url: '/saas/smart_maintenance/fault_warning/handle',
    method: xhr.post,
    type: xht.body
  },
  getProviders: {
    url: '/saas/provider/child_tree',
    method: xhr.get
  },
  getRecommendEngineer: {
    url: '/saas/engineer/recommend',
    method: xhr.get
  }
}

export const system = {
  roleList: {
    url: '/system/role_list',
    method: xhr.get,
    type: xht.query
  },
  personnelList: {
    url: '/system/personnel_list',
    method: xhr.get,
    type: xht.query
  },
  stationList: {
    url: '/system/station_list',
    method: xhr.get,
    type: xht.query
  }
}

export const resource = {
  stationEngineer: {
    url: '/resource/engineer',
    method: xhr.get,
    type: xht.query
  },
  bankClient: {
    url: '/resource/bankClient',
    method: xhr.get,
    type: xht.query
  },
  clientContact: {
    url: '/resource/clientContact',
    method: xhr.get,
    type: xht.query
  },
  personOutsourcesList: {
    url: '/resource/personOutsourceList',
    method: xhr.get,
    type: xht.query
  },
  clientOutsourcesList: {
    url: '/resource/clientOutsourceList',
    method: xhr.get,
    type: xht.query
  },
  clientStaffs: {
    url: '/resource/clientStaffs',
    method: xhr.get,
    type: xht.query
  }
}

export const org = {
  orgStations: {
    url: '/org/orgStations',
    method: xhr.get,
    type: xht.query
  },
  clientStations: {
    url: '/org/clientStations',
    method: xhr.get,
    type: xht.query
  }
}

export const contract = {
  contractList: {
    url: '/saas/contract/page',
    method: xhr.post,
    type: xht.body
  },
  //保存合同信息
  contractSave: {
    url: '/saas/contract/save',
    method: xhr.post,
    type: xht.body
  },
  contractDetail: {
    url: '/saas/contract/detail',
    method: xhr.get,
    type: xht.query
  }
}

export const customer = {
  customerListByQuarter: {
    url: '/saas/maintain/plan/customer/list_with_quarter',
    method: xhr.post,
    type: xht.query
  },
  customerTree: {
    url: '/saas/customer/tree',
    method: xhr.get,
    type: xht.query
  },
  customerCurrentTree: {
    url: '/saas/customer/list_with_provider',
    method: xhr.get,
    type: xht.query
  },
  queryChildClientsById: {
    url: '/saas/customer/child_with_self',
    method: xhr.get,
    type: xht.query
  },

  queryCustomerContacts: {
    url: '/saas/customer/contact/list',
    method: xhr.post,
    type: xht.query
  },

  customerDetail: {
    url: '/saas/customer/detail',
    method: xhr.get,
    type: xht.query
  },
  customerCreateAndEdit: {
    method: xhr.post,
    type: xht.body
  },
  deleteCustomerItem: {
    url: '/saas/customer/contact/delete',
    method: xhr.get,
    type: xht.query
  },
  customerList: {
    url: '/saas//customer/contact/list',
    method: xhr.get,
    type: xht.query
  },
  queryEmployeesByClientId: {
    url: '/saas/provider/employee',
    method: xhr.get,
    type: xht.query
  },
  clientUpdate: {
    url: '/saas/customer/update',
    method: xhr.post,
    type: xht.body
  },
  clientAdd: {
    url: '/saas/customer/add',
    method: xhr.post,
    type: xht.body
  },
  clientDelete: {
    url: '/saas/customer/remove',
    method: xhr.post,
    type: xht.query
  },
  customerContactUpdate: {
    url: '/saas/customer/contact/update',
    method: xhr.post,
    type: xht.query
  },
  customerContactAdd: {
    url: '/saas/customer/contact/add',
    method: xhr.post,
    type: xht.query
  },
  customerContactDelete: {
    url: '/saas/customer/contact/delete',
    method: xhr.post,
    type: xht.query
  },
  customerDetailWithMac: {
    url: '/saas/customer/detail_with_mac',
    method: xhr.get,
    type: xht.query
  },
  //从银行库里选择 客户
  bankChildrenList: {
    url: '/saas/customer/bank/children',
    method: xhr.get,
    type: xht.query
  },
  backChildrenWithParent: {
    url: '/saas/customer/bank/children_with_pid',
    method: xhr.get,
    type: xht.query
  },
  bankCustomerDetail: {
    url: '/saas/customer/bank/detail',
    method: xhr.get,
    type: xht.query
  },
  customerTreeWithProvider: {
    url: '/saas/customer/list_with_provider',
    method: xhr.get,
    type: xht.query
  },
  customerListById: {
    url: '/saas/maintain/provider/list',
    method: xhr.get,
    type: xht.query
  },
  customerTreeList: {
    url: '/saas/maintain/customer/tree',
    method: xhr.get,
    type: xht.query
  }
}

export const provider = {
  createPlan: {
    url: '/saas/maintain/plan/execute',
    method: xhr.post,
    type: xht.body
  },
  providerPlanDelete: {
    url: '/saas/maintain/provider/remove',
    method: xhr.post,
    type: xht.body
  },
  providerPlanAdd: {
    url: '/saas/maintain/provider/create',
    method: xhr.post,
    type: xht.body
  },
  providerList: {
    url: '/saas/provider/list',
    method: xhr.get,
    type: xht.query
  },
  providerTree: {
    url: '/saas/provider/child_tree',
    method: xhr.get,
    type: xht.query
  },
  providerAllTree: {
    url: '/saas/provider/tree',
    method: xhr.get,
    type: xht.query
  },
  //系统下 员工列表  网点员工列表
  employeeList: {
    url: '/saas/provider/employee',
    method: xhr.get,
    type: xht.query
  },
  //系统上级员工列表，选来做管理员
  employeeParentList: {
    url: '/saas/provider/employee/parent',
    method: xhr.get,
    type: xhr.query
  },
  employeeAdd: {
    url: '/saas/provider/add/employee',
    method: xhr.post,
    type: xht.body
  },
  employeeUpdate: {
    url: '/saas/provider/update/employee',
    method: xhr.post,
    type: xht.body
  },
  providerChildList: {
    url: '/saas/provider/child',
    method: xhr.get,
    type: xht.query
  },
  providerAdd: {
    url: '/saas/provider/add',
    method: xhr.post,
    type: xht.body
  },
  providerUpdate: {
    url: '/saas/provider/update',
    method: xhr.post,
    type: xht.body
  },
  //删除网点
  providerDelete: {
    url: '/saas/provider/delete',
    method: xhr.post,
    type: xht.query
  },
  //服务商详情信息
  providerDetail: {
    url: '/saas/provider/detail',
    method: xhr.get,
    type: xht.query
  },
  //服务商更新logo
  providerUpdateLogo: {
    url: '/saas/provider/update_logo',
    method: xhr.post,
    type: xht.query
  },
  //服务商修改商户信息
  providerUpdateService: {
    url: '/saas/provider/update/service',
    method: xhr.post,
    type: xht.body
  },
  providerEmployeeDelete: {
    url: '/saas/provider/delete/employee',
    method: xhr.post,
    type: xht.query
  }
}

export const permission = {
  //没有分页 用于下拉选择
  roleListOrg: {
    url: '/platform/role/list/org',
    method: xhr.post,
    type: xht.query
  },
  //携带分页
  roleList: {
    url: '/platform/role/list',
    method: xhr.post,
    type: xht.body
  },
  menuTree: {
    url: '/platform/menu/user/tree',
    method: xhr.get,
    type: xht.query
  }
}

export const outsource = {
  //企业外包商列表
  enterpriseOutsourceList: {
    url: '/saas/outsourcer/enterprise/page',
    method: xhr.post,
    type: xht.body
  },
  //个人外包商列表
  personnelOutsourceList: {
    url: '/saas/outsourcer/person/page',
    method: xhr.post,
    type: xht.body
  },
  //新增编辑个人外包商
  personnelOutsourceSave: {
    url: '/saas/outsourcer/person/save',
    method: xhr.post,
    type: xht.body
  },
  //新增编辑企业外包商
  enterpriseOutsourceSave: {
    url: '/saas/outsourcer/enterprise/save',
    method: xhr.post,
    type: xht.body
  },
  //获取企业外包商详情
  enterpriseOutsourceDetail: {
    url: '/saas/outsourcer/enterprise/detail',
    method: xhr.get,
    type: xht.query
  },
  //个人外包商想抢
  personnelOutsourceDetail: {
    url: '/saas/outsourcer/person/detail',
    method: xhr.get,
    type: xht.query
  },
  //审核外包商
  outsourceAudit: {
    url: '/saas/outsourcer/check',
    method: xhr.post,
    type: xht.query
  },
  //外包商下员工列表
  outsourceEmployeeList: {
    url: '/saas/outsourcer/employee/page',
    method: xhr.post,
    type: xht.body
  },
  //编辑保存员工
  outsourceEmployeeSave: {
    url: '/saas/outsourcer/employee/save',
    method: xhr.post,
    type: xht.body
  },
  //员工详情
  employeeDetail: {
    url: '/saas/outsourcer/employee/detail',
    method: xhr.get,
    type: xht.query
  },
  //外包商人员审核
  employeeAudit: {
    url: '/saas/outsourcer/employee/check',
    method: xhr.post,
    type: xht.query
  },
  batchEmployeeAdd: {
    url: '/saas/outsourcer/employee/import',
    method: xhr.post,
    type: xht.body
  },
  //外包商列表 不分页下拉选择用
  outsourceList: {
    url: '/saas/outsourcer/list',
    method: xhr.get,
    type: xht.query
  }
}

//工程师模块相关接口
export const engineer = {
  engineerList: {
    url: '/saas/engineer/list',
    method: xhr.post,
    type: xht.body
  },
  //添加工程师
  engineerAdd: {
    url: '/saas/engineer/add',
    method: xhr.post,
    type: xht.query
  },
  //编辑工程师
  engineerEdit: {
    url: '/saas/engineer/update',
    method: xhr.get,
    type: xht.query
  },
  batchEngineerAdd: {
    url: '/saas/engineer/add/batch',
    method: xhr.post,
    type: xht.body
  },
  engineerDelete: {
    url: '/saas/engineer/remove',
    method: xhr.post,
    type: xht.body
  },
  //获取推荐工程师
  engineerRecommend: {
    url: '/saas/engineer/recommend',
    method: xhr.get,
    type: xht.query
  },
  //工程师详情
  engineerDetail: {
    url: '/saas/engineer/detail',
    method: xhr.get,
    type: xht.query
  }
}

export const process = {
  listGroup: {
    url: '/saas/process/project/list_with_group',
    method: xhr.get,
    type: xht.query
  },
  projectAdd: {
    url: '/saas/process/project/add',
    method: xhr.post,
    type: xht.body
  },
  projectSwitch: {
    url: '/saas/process/project/switch',
    method: xhr.get,
    type: xht.query
  },
  projectDelete: {
    url: '/saas/process/project/delete',
    method: xhr.get,
    type: xht.query
  },
  maintainPage: {
    url: '/saas/maintain/page',
    method: xhr.post,
    type: xht.body
  },
  maintainTemplatePage: {
    url: '/saas/maintain/template/page',
    method: xhr.post,
    type: xht.body
  },
  maintainTemplateList: {
    url: '/saas/maintain/template/list',
    method: xhr.get,
    type: xht.body
  },
  maintainRelation: {
    url: '/saas/maintain/relation',
    method: xhr.post,
    type: xht.query
  },
  maintainRemove: {
    url: '/saas/maintain/remove',
    method: xhr.post,
    type: xht.body
  },
  maintainCreate: {
    url: '/saas/maintain/create',
    method: xhr.post,
    type: xht.body
  },
  maintainTemplateRemove: {
    url: '/saas/maintain/template/remove',
    method: xhr.post,
    type: xht.query
  },
  maintainTemplateCopy: {
    url: '/saas/maintain/template/all/copy',
    method: xhr.post,
    type: xht.query
  },
  maintainTemplateModify: {
    url: '/saas/maintain/template/modify',
    method: xhr.post,
    type: xht.body
  },
  maintianTemplateContentCreate: {
    url: '/saas/maintain/template/device_type/content/create',
    method: xhr.post,
    type: xht.body
  },
  maintainDeviceType: {
    url: '/saas/maintain/template/device_type/page',
    method: xhr.get,
    type: xht.query
  },
  maintainDeviceContent: {
    url: '/saas/maintain/template/device_type/content/page',
    method: xhr.post,
    type: xht.body
  },
  maintainTemplateContentRemove: {
    url: '/saas/maintain/template/device_type/content/remove',
    method: xhr.post,
    type: xht.query
  },
  maintainEdit: {
    url: '/saas/maintain/modify',
    method: xhr.post,
    type: xht.body
  },
  maintainTemplateCreate: {
    url: '/saas/maintain/template/create',
    method: xhr.post,
    type: xht.body
  },
  maintainDeviceTypeCreate: {
    url: '/saas/maintain/template/device_type/create',
    method: xhr.post,
    type: xht.body
  },
  //维保编辑设备名称
  maintainDeviceEdit: {
    url: '/saas/maintain/template/device_type/modify',
    method: xhr.post,
    type: xht.body
  },
  //维保编辑巡检内容
  maintainContentEdit: {
    url: '/saas/maintain/template/device_type/content/modify',
    method: xhr.post,
    type: xht.body
  },
  maintainGetListById: {
    url: '/saas/maintain/provider/list',
    method: xhr.get,
    type: xht.query
  },
  //维保编辑巡检内容
  maintainPlanPage: {
    url: '/saas/maintain/plan/page',
    method: xhr.post,
    type: xht.body
  },
  //查询维保计划列表
  maintainPlanList: {
    url: '/saas/maintain/plan/list',
    method: xhr.post,
    type: xht.body
  },
  //维保编辑巡检内容
  maintainPlanRemove: {
    url: '/saas/maintain/plan/remove',
    method: xhr.post,
    type: xht.body
  },
  //维保编辑巡检内容
  maintainPlanTemplateModify: {
    url: '/saas/maintain/plan/template/modify',
    method: xhr.get,
    type: xht.query
  }
}

export const device = {
  //根据类型查询设备或者故障类型信息
  deviceFaultList: {
    url: '/saas/device_fault/list_with_type',
    method: xhr.get,
    type: xht.query
  }
}

export const matter = {
  // 查询事项类型分页
  matterTypePage: {
    url: '/saas/matter/type/page',
    method: xhr.post,
    type: xht.body
  },
  // 查询事项类型分页
  matterTypeCreate: {
    url: '/saas/matter/type/create',
    method: xhr.post,
    type: xht.body
  },
  // 删除事项类型
  matterTypeDelete: {
    url: '/saas/matter/type/delete',
    method: xhr.get,
    type: xht.query
  },
  // 修改事项类型
  matterTypeModify: {
    url: '/saas/matter/type/modify',
    method: xhr.post,
    type: xht.body
  },
  // 批量删除事项类型
  matterTypeDeleteBatch: {
    url: '/saas/matter/type/delete/batch',
    method: xhr.get,
    type: xht.query
  },
  // 批量删除事项类型
  matterOrderCreate: {
    url: '/saas/matter/order/create',
    method: xhr.post,
    type: xht.body
  },
  // 事项单相关接口
  matterTypeList: {
    url: '/saas/matter/type/list',
    method: xhr.get,
    type: xht.query
  },
  // 查询事项单分页列表
  matterOrderPage: {
    url: '/saas/matter/order/page',
    method: xhr.post,
    type: xht.body
  },
  // 获取事项单详情
  matterOrderDetail: {
    url: '/saas/matter/order/detail',
    method: xhr.get,
    type: xht.query
  },
  // 获取事项单信息
  matterOrderInfo: {
    url: '/saas/matter/order/info',
    method: xhr.get,
    type: xht.query
  },
  // 关闭工单
  matterOrderClose: {
    url: '/saas/matter/order/close',
    method: xhr.get,
    type: xht.query
  },
  // 派单
  matterOrderDispatch: {
    url: '/saas/matter/order/dispatch',
    method: xhr.post,
    type: xht.body
  },
  // 改派单
  matterOrderRedispatch: {
    url: '/saas/matter/order/redispatch',
    method: xhr.post,
    type: xht.body
  },
  // 评价单
  matterOrderComment: {
    url: '/saas/matter/order/comment',
    method: xhr.post,
    type: xht.body
  },
  // 评价巡检单
  inspectOrderComment: {
    url: '/saas/inspect/order/comment',
    method: xhr.post,
    type: xht.body
  }
}

export const informatization = {
  informatizationProjectPage: {
    url: '/saas/informatization/project/page',
    method: xhr.post,
    type: xht.body
  },
  informatizationEquipmentPage: {
    url: '/saas/informatization/equipment/page',
    method: xhr.post,
    type: xht.body
  },
}



// WEBPACK FOOTER //
// ./src/config/apis.js